<template>
    <form @submit.prevent="submit()" class="flex-container" id="idPostForm">
        <div class="left">

            <media-image ref="mediaImage" model_type="Post" v-bind:model_id="this.post_id" collection_name="post_image" v-on:file-uploaded="newThumbnailUploaded" v-bind:thumb_size="180"></media-image>

            <div class="form-group" :class="{'has-error': form.errors.has('tags')}">
                <label for="tags">Category</label>
                <post-category-select v-model="form.post_category_id"></post-category-select>
            </div>


            <div class="form-group" :class="{'has-error': form.errors.has('tags')}">
                <label for="tags">Tags</label>
                <vue-input-tag :tags.sync="tags"></vue-input-tag>
            </div>
            <div class="form-group" :class="{'has-error': form.errors.has('is_published')}">
                <label>Status</label>
                <p>
                    <label><input type="checkbox" name="is_published" v-model="form.is_published"> Published</label>
                </p>
            </div>
            <div class="form-group" v-if="form.is_published">
                <label for="social_network">Publish On</label>
                <p :class="{'has-error': form.errors.has('published_on_website')}">
                    <label><input type="checkbox" name="published_on_website" v-model="form.published_on_website"> Website</label>
                </p>
                <p :class="{'has-error': form.errors.has('published_on_newsfeed')}">
                    <label><input type="checkbox" name="published_on_newsfeed" v-model="form.published_on_newsfeed"> Member Newsfeed</label>
                </p>
                <p :class="{'has-error': form.errors.has('publish_facebook')}" v-if="facebookEnabled">
                    <label><input type="checkbox" :disabled="facebookPublished" name="publish_facebook" v-model="form.publish_facebook"> Facebook</label><br>
                    <select v-if="form.publish_facebook && pages.length > 0 && !facebookPublished" v-model="form.facebook_page_id" class="form-control">
                        <option v-for="page in pages" :value="page.id">{{ page.name }}</option>
                    </select>
                </p>
                <p :class="{'has-error': form.errors.has('publish_twitter')}" v-if="twitterEnabled">
                    <label><input type="checkbox" :disabled="twitterPublished" name="publish_twitter" v-model="form.publish_twitter"> Twitter</label>
                </p>
            </div>

        </div>
        <div class="right">
            <div class="form-group" :class="{'has-error': form.errors.has('title')}">
                <input type="text" class="form-control" :class="{'is-invalid': form.errors.has('title')}" name="title" placeholder="Title" id="title" v-model="form.title">

                <span class="invalid-feedback help-block" v-if="form.errors.has('title')" v-text="form.errors.get('title')"></span>
            </div>
            <div class="form-group" :class="{'has-error': form.errors.has('content')}">
                <textarea name="content" id="content" placeholder="Enter your content here" :class="{'is-invalid': form.errors.has('content')}" cols="30" rows="10" class="form-control" v-model="form.content"></textarea>
                
                <span class="invalid-feedback help-block" v-if="form.errors.has('content')" v-text="form.errors.get('content')"></span>
            </div>

            <div class="form-group">
                <label>Attachments</label>
                <media-attachment ref="mediaAttachmentManager" model_type="Post" v-bind:model_id="this.post_id" :can_manage_files="canManagePosts" collection_name="post_attachments"></media-attachment>
            </div>

        </div>

    </form>

</template>

<style scoped>
.flex-container {
    display: flex;
    flex-flow: row nowrap;
    margin-bottom: 16px;
}
.left {
    flex: 0 0 180px;
    padding: 8px;
    background-color: #ccc;
    border-radius: 4px;
}
.right {
    margin-left: 16px;
    float: left;
    flex: 1 0;
    padding: 8px;
    background-color: #eee;
    border-radius: 4px;
}
#image-label {
    width: 180px;
    height: 180px;
    border: 1px solid #006;
    border-radius: 4px;
    overflow: hidden;
    position: relative;
    text-align: center;
    vertical-align: middle;
}
#image-label input[type=file] {
    cursor: inherit;
    display: block;
    font-size: 999px;
    filter: alpha(opacity=0);
    min-height: 100%;
    min-width: 100%;
    opacity: 0;
    position: absolute;
    right: 0;
    text-align: right;
    top: 0;
}
#dropArea {
  border: 2px solid #ccc;
  border-radius: 20px;
  width: 100%;
  font-family: sans-serif;
  margin: 0px auto;
  padding: 32px;
}
#dropArea.highlight {
  border-color: blue;
}
p {
  margin-top: 0;
}
.my-form {
  margin-bottom: 10px;
}
#gallery {
  margin-top: 10px;
}
#gallery img {
  width: 150px;
  margin-bottom: 10px;
  margin-right: 10px;
  vertical-align: middle;
}
.button {
  display: inline-block;
  padding: 10px;
  background: #00f;
  cursor: pointer;
  border-radius: 5px;
  border: 1px solid #ccc;
}
.button:hover {
  background: #0f0;
}
#fileElem {
  display: none;
}
.file_card {
    width: 112px;
    border: 1px #ccc;
    border-radius: 8px;
    padding: 0px;
    margin: 16px;
    float: left;
}
.file_card .caption {
    width: 100%;
    height: 80px;
    text-overflow: hidden;
    margin: 8px auto;
    text-align: center;
    font-size: 1em;
    word-wrap: break-word;
}
.file_card .icon {
    width: 112px;
    height: 96px;
    padding: 16px 16px 0 16px; /* Padding left / right / top for the image */
}
.file-card .icon:hover {
    cursor: pointer;
}
.actions {
    text-align: center;
}
</style>
<script>
    import _ from 'lodash';
    import axios from 'axios';
    import Form from '../utils/Form.js';
    import VueInputTag from 'vue-input-tag';

    export default {
        components: {
            VueInputTag
        },

        props: [
            'postId',
            'canManagePosts'
        ],

        data() {
            return {
                type: 'new',
                post_id: this.postId,
                post: null,
                thumbail: null,
                form: new Form({
                    title: null,
                    content: null,
                    thumbnail_id: null,
                    publish_facebook: false,
                    publish_twitter: false,
                    published_on_website: false,
                    published_on_newsfeed: false,
                    facebook_page_id: null,
                    tags: null,
                    is_published: true,
                    post_category_id: null
                }),
                tags: [],
                club: null,
                postAttachments: [],
                pages: []
            };
        },

        mounted() {
            this.init();
        },

        computed: {
            twitterEnabled: function () {
                if (this.club) {
                    let twitterToken = _.find(this.club.social_tokens, (item) => {
                        return item.provider === 'twitter';
                    });

                    if (twitterToken) {
                        return true;
                    }
                }

                return false;
            },

            facebookEnabled: function () {
                if (this.club) {
                    let twitterToken = _.find(this.club.social_tokens, (item) => {
                        return item.provider === 'facebook';
                    });

                    if (twitterToken) {
                        return true;
                    }
                }

                return false;
            },

            twitterPublished: function () {
                if (this.type == 'update' && this.form.twitter_id) {
                    return true;
                }

                return false;
            },

            facebookPublished: function () {
                if (this.type == 'update' && this.form.facebook_id) {
                    return true;
                }

                return false;
            }
        },

        methods: {
            init() {
                console.log('PostForm.init()');
                console.log('PostForm.init() - Post ID: ' + this.post_id);
                this.getClub();

                if (this.post_id) {
                    console.log('PostForm.init() : Loading post')
                    this.type = 'update';
                    this.getPost();
                }
                this.$refs.mediaImage.refreshFiles();
            },
            cancel() {
                this.resetForm();
                this.$refs.mediaImage.resetTmpFiles();
                this.$emit('cancel');
            },
            resetForm() {
                this.form = new Form({
                    title: null,
                    content: null,
                    thumbnail_id: null,
                    publish_facebook: false,
                    publish_twitter: false,
                    published_on_website: false,
                    published_on_newsfeed: false,
                    facebook_page_id: null,
                    tags: null,
                    is_published: true,
                    post_category_id: null

                });
                this.post_id = null;
                this.post = null;
                this.thumbnail = null;
                this.tags = [];
                this.type="new";
                this.$refs.mediaImage.setModel("Post", null);
                this.$refs.mediaImage.refreshFiles();

            },
            setPostId(postId) {
                this.post_id = postId;
                this.$refs.mediaImage.setModel("Post", this.post_id);
            },
            newThumbnailUploaded(mediaId) {
                console.log('New thumbnail uploaded - updating form');
                console.log(mediaId);
                this.form.thumbnail_id = mediaId;
            },
            getClub() {
                axios.get('/api/v1/newsfeed/club')
                    .then(response => {
                        this.club = response.data;
                    })
                    .catch(error => {
                        alert(error.message);
                    });
            },

            getPost() {
                let postLoading = this.$loading({ target: '#idPostForm', text: 'Loading post details...' });
                axios.get(`/api/v1/newsfeed/posts/${this.post_id}`)
                    .then(response => {
                        console.log('getPost() : response');
                        console.log(response);
                        postLoading.close();
                        this.post = response.data;
                        this.form = new Form({
                            title: response.data.title,
                            content: response.data.content,
                            thumbnail_id: response.data.thumbnail_id,
                            publish_facebook: response.data.facebook_id ? true : false,
                            publish_twitter: response.data.twitter_id ? true : false,
                            published_on_website: response.data.published_on_website,
                            published_on_newsfeed: response.data.published_on_newsfeed,
                            facebook_id: response.data.facebook_id,
                            twitter_id: response.data.twitter_id,
                            currentThumbnail: response.data.thumbnail ? `/api/v1/newsfeed/posts/${response.data.thumbnail}` : null,
                            facebook_page_id: response.data.facebook_page_id,
                            tags: null,
                            is_published: response.data.is_published,
                            post_category_id: response.data.post_category.id ? response.data.post_category.id : null,

                        });

                        this.tags = response.data.tags;

                        this.$refs.mediaAttachmentManager.setModel("Post", this.post_id);
                        this.$refs.mediaImage.setModel("Post", this.post_id);
                        this.$refs.mediaAttachmentManager.setFiles(this.post.attachments);


                    })
                    .catch(error => {
                        alert(error.message);
                        this.type = 'new';
                    });
            },

            getPages() {
                axios.get('/api/v1/newsfeed/facebook/pages')
                    .then(response => {
                        this.pages = response.data;
                    })
                    .catch(error => {
                        alert(error.message);
                    });
            },

            fileChanged(event) {
                console.log(event.target.files[0]);
                if (this.validateType(event.target.files[0])) {
                    console.log('fileChanged - setting thumbnail');
                    this.form.thumbnail = [event.target.files[0], event.target.files[0].name];
                } else {
                    console.log('fileChanged - file is not an image');
                    this.form.thumbnail = null;
                }
            },

            validateType(file) {
                return file.type.indexOf('image') !== -1;
            },

            submit() {
                let url, method, success_message;

                if (this.type == 'new') {
                    url = '/api/v1/newsfeed/posts';
                    method = 'post';
                    success_message = "Your post was created successfully";
                } else if (this.type == 'update') {
                    url = `/api/v1/newsfeed/posts/${this.post_id}`;
                    method = 'put';
                    success_message = "Your post was updated successfully";
                }

                this.form.submit(method, url)
                    .then(response => {
                        this.$emit('post_saved', success_message)
                        this.resetForm();
                    });
            },

        handleHTTPError(error) {
                if (error.response) {
                    // The request was made and the server responded with a status code
                    // that falls out of the range of 2xx
                    console.log(error.response.data); // Error message
                    console.log(error.response.status);
                    console.log(error.response.headers);
                    // this.$message({message: 'Error: ' + error.response.data, type: 'error'});
                } else if (error.request) {
                    // The request was made but no response was received
                    // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
                    // http.ClientRequest in node.js
                    console.log(error.request);
                    // this.$message({message: 'There was a problem updating the team - please try again.', type: 'error'});
                } else {
                    // Something happened in setting up the request that triggered an Error
                    console.log('Error', error.message);
                    // this.$message({message: 'There was a problem updating the team - please try again.', type: 'error'});
                }
                console.log(error.config);
        },
        },

        watch: {
            form: {
                handler: function(value, oldValue) {
                    if (value.publish_facebook == true && this.pages.length < 2) {
                        this.getPages();
                    }
                },
                deep: true
            },
            tags: {
                handler: function (value, oldValue) {
                    console.log('watch tags_input');
                    console.log(value);
                    console.log(oldValue);
                    this.form.tags = this.tags.join(',');
                }
            }
        }
    }
</script>
